export const FETCH_PAYERS_REQUEST = 'FETCH_PAYERS_REQUEST';
export const FETCH_PAYERS_SUCCESS = 'FETCH_PAYERS_SUCCESS';
export const FETCH_PAYERS_FAILURE = 'FETCH_PAYERS_FAILURE';

export const CREATE_PAYER_REQUEST = 'CREATE_PAYER_REQUEST';
export const CREATE_PAYER_SUCCESS = 'CREATE_PAYER_SUCCESS';
export const CREATE_PAYER_FAILURE = 'CREATE_PAYER_FAILURE';

export const UPDATE_PAYER_REQUEST = 'UPDATE_PAYER_REQUEST';
export const UPDATE_PAYER_SUCCESS = 'UPDATE_PAYER_SUCCESS';
export const UPDATE_PAYER_FAILURE = 'UPDATE_PAYER_FAILURE';

export const DELETE_PAYER_REQUEST = 'DELETE_PAYER_REQUEST';
export const DELETE_PAYER_SUCCESS = 'DELETE_PAYER_SUCCESS';
export const DELETE_PAYER_FAILURE = 'DELETE_PAYER_FAILURE';

export const fetchPayersRequest = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
      type:FETCH_PAYERS_REQUEST,
      payload: { projectId, page, limit, search },
      
    };
    
  };
export const fetchPayersSuccess = (payers) => ({ type: FETCH_PAYERS_SUCCESS, payload: payers });
export const fetchPayersFailure = (error) => ({ type: FETCH_PAYERS_FAILURE, payload: error });

export const createPayerRequest = (data) => ({ type: CREATE_PAYER_REQUEST, payload: data });
export const createPayerSuccess = (payer) => ({ type: CREATE_PAYER_SUCCESS, payload: payer });
export const createPayerFailure = (error) => ({ type: CREATE_PAYER_FAILURE, payload: error });

export const updatePayerRequest = (id, data) => ({ type: UPDATE_PAYER_REQUEST, payload: { id, data } });
export const updatePayerSuccess = (payer) => ({ type: UPDATE_PAYER_SUCCESS, payload: payer });
export const updatePayerFailure = (error) => ({ type: UPDATE_PAYER_FAILURE, payload: error });

export const deletePayerRequest = (id, projectId) => ({ type: DELETE_PAYER_REQUEST, payload: { id, projectId } });
export const deletePayerSuccess = (id) => ({ type: DELETE_PAYER_SUCCESS, payload: id });
export const deletePayerFailure = (error) => ({ type: DELETE_PAYER_FAILURE, payload: error });
